import { useDispatch, useSelector } from 'react-redux';
import { InlineLink, Txt } from '@vst/beam';
import { Trans, useTranslation } from 'react-i18next';

import { ROUTES } from '@app/router/constants';
import { PaymentMethodLogo } from '@app/components/PaymentMethodLogo';
import { useNavigate } from '@app/hooks';
import { selectBillingInfo } from '@app/redux/billingInfo';
import { Route, setBillingNav } from '@app/redux/billingNav';
import { postOverviewMessage } from '@app/redux/utils';
import { getAutopayTranslationContext } from '@app/utils';
import { EventTypes } from '@app/types';

import styles from './autopay-method.module.scss';

export const OverviewAutoPayMethod = (): JSX.Element => {
  const { t } = useTranslation('Overview', { keyPrefix: 'balanceCard' });
  const { goTo } = useNavigate();
  const dispatch = useDispatch();
  const {
    billingInfo: { autoPay },
  } = useSelector(selectBillingInfo);

  const navigateToAddPaymentMethod = (e: any) => {
    e.preventDefault();

    dispatch(postOverviewMessage({ eventType: EventTypes.PayBill }));
    dispatch(setBillingNav({ route: Route.Autopay }));
    goTo(ROUTES.BILLING);
  };

  return (
    <div id="autoPay" className={styles['container']}>
      <PaymentMethodLogo width="36px" name={autoPay?.isExpired ? null : autoPay?.paymentMethod} />

      <Txt variant="smallRegular" ml="16px" data-cy="overview-autoPay">
        <Trans ns="Summary" i18nKey="overviewPage.autoPay" values={getAutopayTranslationContext(autoPay, true)} />{' '}
        {!autoPay && (
          <InlineLink variant="secondary" theme="dark" href="" onClick={navigateToAddPaymentMethod} data-cy="enroll">
            {t('enrollLink')}
          </InlineLink>
        )}
      </Txt>
    </div>
  );
};
